import axios from "axios";
import { Api } from "./api";

export interface IRoom {
	ID: number;
	Number: number;
	Groups: string;
	Registrations: string;
	Beds: string;
	Description: string;
	Occupants?: string;
	OwnReg: number;
}
export class RoomApi extends Api {

	private readonly urlRegPart = "room/";
	public constructor() {
		super();
	}

	protected get BaseUrl() {
		return super.BaseUrl + this.urlRegPart;
	}

	public async load(id?: number): Promise<IRoom[]> {
		const user = await this.executeWithErrorHandling(() => axios.get<IRoom[]>(this.buildRegistrationUrl(id), this.Config));

		return user.data;
	}

	private buildRegistrationUrl(id?: number) {
		return this.BaseUrl + (id === undefined ? "" : `${id}/`);
	}

}
